import React from 'react'
import TealToolTip from 'components/TealToolTip'
import getUrl from 'front-end-core/core/url'
import { PRECEDENTS_CONTENT } from 'constants/controllers'
import Icon from 'components/shared/Icon'
import ConfirmModal from 'components/shared/ConfirmModal'
import fcObserveRequest from 'helpers/fcObserveRequest'
import notificationToast from 'helpers/notificationToast'
import ErrorIcon from '@material-ui/core/SvgIcon/SvgIcon'
import CheckIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Warning'
import { toast } from 'react-toastify'
import Route from 'route-parser'
import { URL_DOCUMENT } from 'constants/urls'
import selectAolName from 'redux/selectors/selectAolName'
import { useSelector } from 'react-redux'
import { refreshSectionPrecedents } from 'services/PrecedentsService'
import { isValidResponse } from 'front-end-core/helpers/dataflow'
import { delay, concatMap, first } from 'rxjs/operators'

const documentRoute = (props) => new Route(URL_DOCUMENT).reverse(props)

const AdminActions = ({ title, name, id, view, sectionId, pageToggleOverlay, flavour }) => {
  const aol = useSelector(selectAolName)

  const handleDeleteClick = () => {
    pageToggleOverlay(
      <ConfirmModal
        message={`Are you sure you want to delete "${title || name}"?`}
        confirmText='Yes'
        cancelText='No'
        confirmAction={() => {
          fcObserveRequest({
            url: documentRoute({ aol, id }),
            method: 'DELETE'
          }).pipe(
            delay(800),
            concatMap(response => {
              if (!isValidResponse(response)) {
                throw new Error(`Failed to delete '${title}'`)
              } else {
                return refreshSectionPrecedents(aol)
              }
            }),
            first()
          ).subscribe(
            responses => {
              notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, `Deleted '${title}'`)
              if (responses.some(response => !isValidResponse(response))) {
                notificationToast(<WarningIcon />, toast.TYPE.WARNING, 'Failed to refresh precedents, please refresh the page', 'bg-chocolate')
              }
            },
            error => {
              notificationToast(<ErrorIcon />, toast.TYPE.ERROR, error.message, 'bg-indian-red white')
            }
          )
        }}
      />
    )
  }

  return (
    <>
      {/* Edit */}
      <TealToolTip title='Edit'>
        <a
          href={getUrl(PRECEDENTS_CONTENT, { aol, view, sectionId, precedentId: id })}
          className='mh2'
        >
          <Icon className='w6 black' name='icon-pencil' />
        </a>
      </TealToolTip>
      {/* Delete */}
      <TealToolTip title='Delete'>
        <a
          href={null}
          className='pointer mh2'
          onClick={handleDeleteClick}
        >
          <Icon className='w6 black' name='icon-close' />
        </a>
      </TealToolTip>
    </>
  )
}

export default AdminActions
